import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  height: 100vh;

  background: ${({ theme }) => theme.colors.background};

  position: relative;
  overflow: hidden;
`;

export const Main = styled.main`
  display: flex;
  flex-direction: column;
  width: 100%;

  margin-bottom: 8.6rem;
  @media (min-width: 768px) {
    margin-bottom: 0;
  }
`;

export const Content = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 30px;
  max-height: 100%;
  overflow-y: auto;

  flex: 1;

  scrollbar-width: none;

  /* ::-webkit-scrollbar {
    display: none;
  } */

  background: #0f0f0f;
`;
